import {
  act,
  capUnipharm,
  ceido,
  clubDuComptoir,
  dephie,
  fspf,
  giphar,
  giropharm2,
  labofficine,
  MFO,
  normandiepharma,
  oxygenpharma,
  pharma2m,
  pharmaConsulting,
  pharmUppEssential,
  pharmUppUltra,
  settings37dms,
  soloDefimedoc,
  sponsoring,
  synaps,
  teampharma1,
  teams,
  totum6,
  ubipharm,
  urpsPharmaciens,
  uspo,
} from 'constants/discountModals'
import {
  defaultSubscriptionDetails,
  endDateSubscriptionDetails,
  threeMonthsSubscriptionDetails,
  twoMonthsSubscriptionDetails,
} from 'constants/subscription'

export const isGiphar = () =>
  window.location.origin === import.meta.env.VITE_GIPHAR_URL

export const isFspf = () =>
  window.location.origin === import.meta.env.VITE_FSPF_URL

export const isGiropharm2 = () =>
  window.location.origin === import.meta.env.VITE_GIROPHARM2_URL

export const isUspo = () =>
  window.location.origin === import.meta.env.VITE_USPO_URL

const isTeams = () =>
  window.location.origin === import.meta.env.VITE_TEAMS_URL

export const isLabofficine = () =>
  window.location.origin === import.meta.env.VITE_LABOFFICINE_URL

export const isUbipharm = () =>
  window.location.origin === import.meta.env.VITE_UBIPHARM_URL

const isClubDuComptoir = () =>
  window.location.origin === import.meta.env.VITE_CLUB_DU_COMPTOIR_URL

export const isTotum6 = () =>
  window.location.origin === import.meta.env.VITE_TOTUM6_URL

export const isPharmUppEssential = () =>
  window.location.origin === import.meta.env.VITE_PHARM_UPP_ESSENTIAL_URL

export const isPharmUppUltra = () =>
  window.location.origin === import.meta.env.VITE_PHARM_UPP_ULTRA_URL

export const isSoloDefimedoc = () =>
  window.location.origin === import.meta.env.VITE_SOLO_DEFIMEDOC_URL

export const isPharmaConsulting = () =>
  window.location.origin === import.meta.env.VITE_PHARMA_CONSULTING_URL

export const isCapUnipharm = () =>
  window.location.origin === import.meta.env.VITE_CAP_UNIPHARM_URL

export const isUrpsPharmaciens = () =>
  window.location.origin === import.meta.env.VITE_URPS_PHARMACIENS_URL

export const isDephie = () =>
  window.location.origin === import.meta.env.VITE_DEPHIE_URL

export const isCeido = () =>
  window.location.origin === import.meta.env.VITE_CEIDO_URL

export const isAct = () =>
  window.location.origin === import.meta.env.VITE_ACT_URL

export const isSponsoring = () =>
  window.location.origin === import.meta.env.VITE_SPONSORING_URL

export const isOxygenpharma = () =>
  window.location.origin === import.meta.env.VITE_OXYGENPHARMA_URL

export const isPharma2m = () =>
  window.location.origin === import.meta.env.VITE_PHARMA2M_URL

export const is37DMS = () => window.location.origin === import.meta.env.VITE_37DMS_URL

export const isTeampharma1 = () => window.location.origin === import.meta.env.VITE_TEAMPHARMA1_URL

export const isMFO = () => window.location.origin === import.meta.env.VITE_MFO_URL

export const isSynaps = () => window.location.origin === import.meta.env.VITE_SYNAPS_URL

export const isNormandiepharma = () => window.location.origin === import.meta.env.VITE_NORMANDIEPHARMA_URL

export const hasModal = () =>
  isGiphar()
  || isFspf()
  || isGiropharm2()
  || isUspo()
  || isTeams()
  || isLabofficine()
  || isUbipharm()
  || isClubDuComptoir()
  || isTotum6()
  || isPharmUppEssential()
  || isPharmUppUltra()
  || isSoloDefimedoc()
  || isPharmaConsulting()
  || isCapUnipharm()
  || isUrpsPharmaciens()
  || isDephie()
  || isCeido()
  || isAct()
  || isSponsoring()
  || isOxygenpharma()
  || isPharma2m()
  || is37DMS()
  || isTeampharma1()
  || isMFO()
  || isSynaps()
  || isNormandiepharma()

export const isSubdomain = () => hasModal()

const isSubdomainWithTwoMonthsOfTrialPeriod = () => isTeams() || isLabofficine() || isGiropharm2() || isGiphar() || isFspf() || isUspo() || isClubDuComptoir() || isPharmUppEssential() || isPharmaConsulting() || isCapUnipharm() || isUrpsPharmaciens() || isDephie() || isCeido() || isAct() || isSponsoring() || isOxygenpharma() || isPharma2m() || is37DMS() || isTeampharma1() || isMFO() || isSynaps()

const isSubdomainWithThreeMonthsOfTrialPeriod = () => isTotum6()

const isSubdomainWithEndDateSubscriptionDetails = () => isNormandiepharma()

export const getSubscriptionDetails = (isTeamMensualSubscription = false) => {
  if (isSubdomainWithTwoMonthsOfTrialPeriod() && isTeamMensualSubscription) {
    return twoMonthsSubscriptionDetails
  }

  if (isSubdomainWithThreeMonthsOfTrialPeriod() && isTeamMensualSubscription) {
    return threeMonthsSubscriptionDetails
  }

  if (isSubdomainWithEndDateSubscriptionDetails() && isTeamMensualSubscription) {
    return endDateSubscriptionDetails
  }

  return defaultSubscriptionDetails
}

export const getDiscountModalData = () => {
  if (isGiphar()) {
    return giphar
  }

  if (isFspf()) {
    return fspf
  }

  if (isGiropharm2()) {
    return giropharm2
  }

  if (isUspo()) {
    return uspo
  }

  if (isTeams()) {
    return teams
  }

  if (isLabofficine()) {
    return labofficine
  }

  if (isUbipharm()) {
    return ubipharm
  }

  if (isClubDuComptoir()) {
    return clubDuComptoir
  }

  if (isTotum6()) {
    return totum6
  }

  if (isPharmUppEssential()) {
    return pharmUppEssential
  }

  if (isPharmUppUltra()) {
    return pharmUppUltra
  }

  if (isSoloDefimedoc()) {
    return soloDefimedoc
  }

  if (isPharmaConsulting()) {
    return pharmaConsulting
  }

  if (isCapUnipharm()) {
    return capUnipharm
  }

  if (isUrpsPharmaciens()) {
    return urpsPharmaciens
  }

  if (isDephie()) {
    return dephie
  }

  if (isCeido()) {
    return ceido
  }

  if (isAct()) {
    return act
  }

  if (isSponsoring()) {
    return sponsoring
  }

  if (isOxygenpharma()) {
    return oxygenpharma
  }

  if (isPharma2m()) {
    return pharma2m
  }

  if (is37DMS()) {
    return settings37dms
  }

  if (isTeampharma1()) {
    return teampharma1
  }

  if (isMFO()) {
    return MFO
  }

  if (isSynaps()) {
    return synaps
  }

  if (isNormandiepharma()) {
    return normandiepharma
  }

  return null
}
